/**
 * A variant's colours are custom properties on the document's root. The server writes them into the page as it
 * arrives (`App\Helpers\VariantStyles`), which covers the first page; this keeps them right afterwards, since
 * logging in or out moves between variants without the page being loaded again.
 *
 * They go on the root element and not the app's own, so that dialogs, which are drawn outside it, have them too.
 */

/** The properties the last call set, so that a variant which sets fewer does not keep the previous one's. */
let applied: string[] = []

/**
 * @param classes The variant's `classes`: custom property names, each with its value.
 * @param root The element to set them on.
 */
export function applyVariantClasses(
    classes: Record<string, unknown> | null | undefined,
    root: HTMLElement = document.documentElement,
): void {
    const wanted = Object.entries(classes ?? {})
        .filter((entry): entry is [string, string] => entry[0].startsWith('--') && typeof entry[1] === 'string')

    applied
        .filter(key => !wanted.some(([wantedKey]) => wantedKey === key))
        .forEach(key => root.style.removeProperty(key))

    wanted.forEach(([key, value]) => root.style.setProperty(key, value))

    applied = wanted.map(([key]) => key)
}
